
import React from "react";

const ApprovalTransactions = () =>{
    return(
        <div className="card">
            <div className="card-header">
                <h5 className="mb-0">Approval Transactions</h5>
            </div>
            <div className="card-block">
                Approval Transactions
            </div>
        </div>
    );
}

export default ApprovalTransactions;